module.exports = __webpack_public_path__ + "media/clients/dalana-2x-d286255d.jpg";